import React, { useEffect, useRef, useState } from "react";
import { v4 as uuidv4 } from "uuid";

/* CSS를 가지고있는 기본 input */
export default function BasicInput({ item, onChange, onClick, value, readOnly, type, textAlign, width, onKeyDown  }) {

    return (
        <input
            autoComplete="off"
            id={uuidv4()}
            className="basic-input"
            name={item.col || ""}
            onChange={onChange && ((e) => onChange(e))}
            onClick={onClick && ((e) => onClick(e))}
            value={value ||""}
            placeholder={item.placeholder || ""}
            // readOnly={readOnly || false}
			readOnly={readOnly || !onChange ? true : false}
			type={type || "text"}
            //disabled={item.disabled || false}
            disabled={readOnly === true &&  item.enable === false }
            hidden={readOnly !== true &&  item.hidden}
			style={{ textAlign: textAlign ?? null , width : width}}
			onKeyDown={onKeyDown && (e => onKeyDown(e))}
        />
    );
}
